import { render, staticRenderFns } from "./BadgeComponent.vue?vue&type=template&id=6eaca45c&scoped=true"
import script from "./BadgeComponent.vue?vue&type=script&lang=js"
export * from "./BadgeComponent.vue?vue&type=script&lang=js"
import style0 from "./BadgeComponent.vue?vue&type=style&index=0&id=6eaca45c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaca45c",
  null
  
)

export default component.exports